import React from 'react'
import Home from '../../components/page-content/home'

export const Page = () => {
  return <Home />
}

export default Page
